// @file utilities relating to wish arrangement settings (group by, sort by etc)
import { POST_COLOR_STRINGS } from '@@/bits/post_color'
import type { LabelledSection, PostColorId, WallGroupColor, WallGroupPost } from '@@/types'

// Determines whether the given group-by object is a section.
export const isSectionGroup = (group: WallGroupPost): group is Required<LabelledSection> => {
  return 'id' in group && 'hashid' in group && 'title' in group && 'sort_index' in group
}

export const isColorGroup = (group: WallGroupPost): group is WallGroupColor => {
  return 'id' in group && POST_COLOR_STRINGS.includes(group.id as PostColorId) // Can assert type since `includes` will perform check for us.
}
